import { render, staticRenderFns } from "./ReContactResearch.vue?vue&type=template&id=5676a654&lang=pug&"
import script from "./ReContactResearch.vue?vue&type=script&lang=js&"
export * from "./ReContactResearch.vue?vue&type=script&lang=js&"
import style0 from "./ReContactResearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports